import { z } from 'zod';

/** Lifecycle — empty payload. */
export const schemaWabaCreatedPayload = z.optional(z.object({}));

export type Schema_WabaCreatedPayload = z.infer<typeof schemaWabaCreatedPayload>;
